import { render, staticRenderFns } from "./TerminalPesagem.vue?vue&type=template&id=1fe795dd&scoped=true"
import script from "./TerminalPesagem.vue?vue&type=script&lang=js"
export * from "./TerminalPesagem.vue?vue&type=script&lang=js"
import style0 from "./TerminalPesagem.vue?vue&type=style&index=0&id=1fe795dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe795dd",
  null
  
)

export default component.exports